import { englishFormattedEuroCurrency } from '@getpopsure/public-utility';
import { SHOW_DECIMAL_VALUE_PRICE_LIMIT } from 'features/recommendationTool/constants';

export const formatDecimalCurrency = (value: number): string =>
  englishFormattedEuroCurrency(
    value > SHOW_DECIMAL_VALUE_PRICE_LIMIT ? Math.round(value) : value,
    true
  );
